import { Map2D, mod } from "@kosmod/kit";
import { TerrainChunk } from "../defs";
import * as three from "three";

// const createChunk = (position: three.Vector2, chunkMap: Map2D<number, number, TerrainChunk>) => {
//   const chunk = { position, version: Symbol(), data: Array2D.fromSize(8, 8, TerrainChunkState.EMPTY) }
//   chunkMap.set(position.x, position.y, chunk)
//   return chunk;
// }

// const writeToTerrain = (coord: three.Vector2, value: TerrainChunkState, chunkMap: Map2D<number, number, TerrainChunk>) => {
//   const chunkPosition = new three.Vector2().copy(coord).divideScalar(8).floor();
//   const chunk = chunkMap.has(chunkPosition.x, chunkPosition.y)
//     ? chunkMap.get(chunkPosition.x, chunkPosition.y)
//     : createChunk(chunkPosition, chunkMap);

//   const x = coord.x - (chunkPosition.x * 8);
//   const y = coord.y - (chunkPosition.y * 8);

//   chunk.data.set(x, y, value);
//   chunk.version = Symbol();
// }

/**
 * 
 * @param box Assuming the box is scaled to "chunk size" (i.e. divided by chunk width/height)
 * @param chunkMap 
 */
export const calcAffectedChunkCoords = (box: three.Box2) => {
  const alignedMin = new three.Vector2(box.min.x, box.min.y).floor();
  const alignedMax = new three.Vector2(box.max.x, box.max.y).floor().addScalar(1);

  const affectedChunks = [] as three.Vector2[];
  for (let y = alignedMin.y; y < alignedMax.y; y++) {
    for (let x = alignedMin.x; x < alignedMax.x; x++) {
      affectedChunks.push(new three.Vector2(x, y))
    }
  }

  return affectedChunks;
}

/**
 * Generate an array of each coordinate
 * of a (assumedly already aligned) box
 * @param box box.min & box.max should already be `.floor()`'d
 */
export function* integerCoordinates(box: three.Box2) {
  const vector = new three.Vector2();
  for (let x = box.min.x; x < box.max.x; x++) {
    for (let y = box.min.y; y < box.max.y; y++) {
      vector.x = x;
      vector.y = y;
      yield vector.clone();
    }
  }
}

/**
 * Often, you want to perform modifications on
 * an clone of a chunk for immutability
 * purposes.
 */
export const cloneChunk = (chunk: TerrainChunk) => {
  return {
    ...chunk,
    data: [...chunk.data]
  }
}

export const getChunkDataIndex = (
  chunkSize: three.Vector2Like,
  target: three.Vector2Like
) => {
  return (target.y * chunkSize.x) + target.x;
}

export function *iterateChunkDataCoords(chunk?: TerrainChunk) {
  for (let i = 0; i < 8 * 8; i++) {
    const y = Math.floor(i / 8);
    const x = mod(i, 8);
    if (chunk)
      yield [(chunk.x * 8) + x, (chunk.y * 8) + y, i] as const;
    else
      yield [x, y, i] as const;
  }
}